import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Button, Form } from "react-bootstrap";
import axios from "axios";
import { useUser } from "./UserContext";
import apiClient from "../Login/apiClient";
import { ToastContainer, toast } from "react-toastify";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
  background-color: #f5f5f5;
`;

const LoginForm = styled(Form)`
  width: 500px;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
`;

const LoginButton = styled(Button)`
  width: 100%;
`;

const SpacedFormGroup = styled(Form.Group)`
  margin-bottom: 15px;
`;

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function ChangePassword() {
  const navigate = useNavigate();

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const handleChangePassword = async (e) => {
    e.preventDefault(); // ★ 追加：フォームのデフォルト送信を止める

    try {
      if (newPassword === confirmNewPassword) {
        await apiClient.post(`${API_BASE_URL}/api/accounts/change-password/`, {
          old_password: oldPassword,
          new_password1: newPassword,
          new_password2: confirmNewPassword,
        });
        navigate("/MyPage", {
          state: { message: "パスワード変更が完了しました！" },
        });
      } else {
        toast.error("パスワードと確認用パスワードが不一致です");
      }
    } catch (error) {
      const errorCode = error?.response?.status;

      if (errorCode === 400) {
        toast.info("入力内容に誤りがあります。");
        console.error(error);
      } else if (errorCode === 500) {
        toast.error("サーバエラーが発生しました。しばらくしてから再度お試しください。");
        console.error(error);
      } else {
        toast.error("予期せぬエラーが発生しました。");
        console.error(error);
      }
    }
  };

  return (
    <React.StrictMode>
      <Container>
        {/* <h2>パスワード変更</h2> */}
        <LoginForm onSubmit={handleChangePassword}>
          <SpacedFormGroup controlId="formBasicUserID">
            <Form.Label>現在のパスワード</Form.Label>
            <Form.Control type="password" value={oldPassword} placeholder="現在のパスワード" onChange={(e) => setOldPassword(e.target.value)} />
          </SpacedFormGroup>
          <SpacedFormGroup controlId="formBasicPassword">
            <Form.Label>新しいパスワード</Form.Label>
            <Form.Control type="password" value={newPassword} placeholder="新しいパスワード" onChange={(e) => setNewPassword(e.target.value)} />
          </SpacedFormGroup>
          <SpacedFormGroup controlId="formBasicPassword">
            <Form.Label>新しいパスワード（確認）</Form.Label>
            <Form.Control type="password" value={confirmNewPassword} placeholder="新しいパスワード（確認）" onChange={(e) => setConfirmNewPassword(e.target.value)} />
          </SpacedFormGroup>
          <LoginButton variant="primary" type="submit" block className="w-90 text-center d-flex align-items-center justify-content-center" style={{ minWidth: "80px", whiteSpace: "nowrap", fontSize: "1.2rem", color: "#ffffff", borderColor: "transparent", backgroundColor: "#6495ed" }}>
            パスワード変更
          </LoginButton>
        </LoginForm>
        <ToastContainer position="top-center" autoClose={3000} />
      </Container>
    </React.StrictMode>
  );
}

export default ChangePassword;
